export default (url: string, branchSlug: string): string => {
    return branchSlug && !/^https?:\/\//i.test(url) ? '/pobocka-' + branchSlug + url : url
}
